import { render, staticRenderFns } from "./PopupRequestContact.vue?vue&type=template&id=2af1f444&"
import script from "./PopupRequestContact.vue?vue&type=script&lang=js&"
export * from "./PopupRequestContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports